import IE from './IE';

export default IE;
